import { LANGUAGE_LOCALES } from './languages';

export const REGION_LOCALE = {
  US: {
    region: 'us',
    locale: LANGUAGE_LOCALES.EN_US
  },
  AU: {
    region: 'au',
    locale: LANGUAGE_LOCALES.EN_AU
  },
  GB: {
    region: 'gb',
    locale: LANGUAGE_LOCALES.EN_GB
  },
  NZ: {
    region: 'nz',
    locale: LANGUAGE_LOCALES.EN_NZ
  },
  MX: {
    region: 'mx',
    locale: LANGUAGE_LOCALES.EN_MX
  },
  CA: {
    region: 'ca',
    locale: LANGUAGE_LOCALES.EN_CA
  },
  FR: {
    region: 'fr',
    locale: LANGUAGE_LOCALES.FR_FR
  },
  DK: {
    region: 'dk',
    locale: LANGUAGE_LOCALES.DA_DK
  },
  CL: {
    region: 'cl',
    locale: LANGUAGE_LOCALES.ES_CL
  }
};

const baseTimeConfig = {
  pm: 'PM',
  am: 'AM',
  formats: {
    default: 'DD-MM-YYYY',
    dby_hm: 'DD-MM-YYYY HH:mm',
    dby_hms_z: 'DD-MM-YYYYTHH:mm:ssZ',
    dby_imp: 'DD MMM YYYY hh:mm A',
    dby_imsp: 'DD MMM YYYY hh:mm:ss A',
    dby_ims: 'DD MMM YYYY hh:mm:ss',
    dby_imsp_moment: 'DD MMM YYYY hh:mm:ss',
    dby: 'DD MMM YYYY',
    bd_hm: 'MMM DD, h:mm A',
    bdo_hm: 'MMM Do, h:mm A',
    bdo_hm_z: 'MMM DD, h:mm A (Z)',
    dby_hm_z: 'DD MMM YYYY HH:mm ZZ',
    dmY_imsp: 'DD/MM/YYYY hh:mm:ss A',
    dmY_imp: 'DD/MM/YYYY hh:mm A',
    dmY: 'DD/MM/YYYY',
    AdBY: 'dddd, DD MMMM YYYY',
    dMy: 'D M Y',
    Md: 'DD MMM'
  },
  formats24H: {
    default: 'DD-MM-YYYY',
    dby_hm: 'DD-MM-YYYY HH:mm',
    dby_hms_z: 'DD-MM-YYYYTHH:mm:ssZ',
    dby_imp: 'DD MMM YYYY HH:mm',
    dby_imsp: 'DD MMM YYYY HH:mm:ss',
    dby_ims: 'DD MMM YYYY HH:mm:ss',
    dby_imsp_moment: 'DD MMM YYYY HH:mm:ss',
    dby: 'DD MMM YYYY',
    bd_hm: 'MMM DD, HH:mm',
    bdo_hm: 'MMM Do, HH:mm',
    bdo_hm_z: 'MMM DD, HH:mm (Z)',
    dby_hm_z: 'DD MMM YYYY HH:mm ZZ',
    dmY_imsp: 'DD/MM/YYYY HH:mm:ss',
    dmY_imp: 'DD/MM/YYYY HH:mm',
    dmY: 'DD/MM/YYYY',
    AdBY: 'dddd, DD MMMM YYYY',
    dMy: 'D M Y',
    Md: 'DD MMM'
  },
  formats12H: {
    default: 'DD-MM-YYYY',
    dby_hm: 'DD-MM-YYYY hh:mm A',
    dby_hms_z: 'DD-MM-YYYYThh:mm:ss A Z',
    dby_imp: 'DD MMM YYYY hh:mm A',
    dby_imsp: 'DD MMM YYYY hh:mm:ss A',
    dby_ims: 'DD MMM YYYY hh:mm:ss A',
    dby_imsp_moment: 'DD MMM YYYY hh:mm:ss A',
    dby: 'DD MMM YYYY',
    bd_hm: 'MMM DD, h:mm A',
    bdo_hm: 'MMM Do, h:mm A',
    bdo_hm_z: 'MMM DD, h:mm A (Z)',
    dby_hm_z: 'DD MMM YYYY hh:mm A ZZ',
    dmY_imsp: 'DD/MM/YYYY hh:mm:ss A',
    dmY_imp: 'DD/MM/YYYY hh:mm A',
    dmY: 'DD/MM/YYYY',
    AdBY: 'dddd, DD MMMM YYYY',
    dMy: 'D M Y',
    Md: 'DD MMM'
  }
};

export const LocalizationConfig = {
  US: {
    country: 'United States',
    ...REGION_LOCALE.US,
    default_time_zone: 'America/Los_Angeles',
    support_email: 'TN360help.us@teletracnavman.com',
    support_doc_link: 'https://learn.teletracnavman.net/Help/TN360/en-US/Default.htm',
    time: {
      pm: 'PM',
      am: 'AM',
      formats: {
        default: 'MM-DD-YYYY',
        dby_hm: 'MM-DD-YYYY HH:mm',
        dby_hms_z: 'MM-DD-YYYYTHH:mm:ssZ',
        dby_imp: 'MMM DD YYYY hh:mm A',
        dby_imsp: 'MMM DD YYYY hh:mm:ss A',
        dby_imsp_moment: 'MMM DD YYYY hh:mm:ss',
        dby: 'MMM DD YYYY',
        bd_hm: 'MMM DD, h:mm A',
        bdo_hm: 'MMM Do, h:mm A',
        bdo_hm_z: 'MMM DD, h:mm A (Z)',
        dby_hm_z: 'MMM DD YYYY HH:mm ZZ',
        dmY_imsp: 'MM/DD/YYYY hh:mm:ss A',
        dmY_imp: 'MM/DD/YYYY hh:mm A',
        dmY: 'MM/DD/YYYY',
        AdBY: 'dddd, MMMM DD YYYY',
        dMy: 'M D Y',
        mdy_iso8061: 'MM-DD-YYYY',
        Md: 'MMM DD'
      },
      formats24H: {
        default: 'MM-DD-YYYY',
        dby_hm: 'MM-DD-YYYY HH:mm',
        dby_hms_z: 'MM-DD-YYYYTHH:mm:ssZ',
        dby_imp: 'MMM DD YYYY HH:mm',
        dby_imsp: 'MMM DD YYYY HH:mm:ss',
        dby_imsp_moment: 'MMM DD YYYY HH:mm:ss',
        dby: 'MMM DD YYYY',
        bd_hm: 'MMM DD, HH:mm',
        bdo_hm: 'MMM Do, HH:mm',
        bdo_hm_z: 'MMM DD, HH:mm (Z)',
        dby_hm_z: 'MMM DD YYYY HH:mm ZZ',
        dmY_imsp: 'MM/DD/YYYY HH:mm:ss',
        dmY_imp: 'MM/DD/YYYY HH:mm',
        dmY: 'MM/DD/YYYY',
        AdBY: 'dddd, MMMM DD YYYY',
        dMy: 'M D Y',
        mdy_iso8061: 'MM-DD-YYYY',
        Md: 'MMM DD'
      },
      formats12H: {
        default: 'MM-DD-YYYY',
        dby_hm: 'MM-DD-YYYY hh:mm A',
        dby_hms_z: 'MM-DD-YYYYTHH:mm:ssZ',
        dby_imp: 'MMM DD YYYY hh:mm A',
        dby_imsp: 'MMM DD YYYY hh:mm:ss A',
        dby_imsp_moment: 'MMM DD YYYY hh:mm:ss A',
        dby: 'MMM DD YYYY',
        bd_hm: 'MMM DD, h:mm A',
        bdo_hm: 'MMM Do, h:mm A',
        bdo_hm_z: 'MMM DD, h:mm A (Z)',
        dby_hm_z: 'MMM DD YYYY hh:mm A ZZ',
        dmY_imsp: 'MM/DD/YYYY hh:mm:ss A',
        dmY_imp: 'MM/DD/YYYY hh:mm A',
        dmY: 'MM/DD/YYYY',
        AdBY: 'dddd, MMMM DD YYYY',
        dMy: 'M D Y',
        mdy_iso8061: 'MM-DD-YYYY',
        Md: 'MMM DD'
      }
    }
  },
  AU: {
    country: 'Australia',
    ...REGION_LOCALE.AU,
    time: baseTimeConfig,
    default_time_zone: 'Australia/Sydney',
    support_email: 'nextgensupport@teletracnavman.com',
    support_doc_link: 'https://learn.teletracnavman.net/Help/TN360/en-AU/Default.htm',
  },
  GB: {
    country: 'United Kingdom',
    ...REGION_LOCALE.GB,
    time: baseTimeConfig,
    default_time_zone: 'Europe/London',
    support_email: 'tn360support-uk@teletracnavman.com',
    support_doc_link: 'https://learn.teletracnavman.net/Help/TN360/en-GB/Default.htm',
  },
  NZ: {
    country: 'New Zealand',
    ...REGION_LOCALE.NZ,
    time: baseTimeConfig,
    default_time_zone: 'Pacific/Auckland',
    support_doc_link: 'https://learn.teletracnavman.net/Help/TN360/en-NZ/Default.htm',
  },
  MX: {
    country: 'Mexico',
    ...REGION_LOCALE.MX,
    time: baseTimeConfig,
    default_time_zone: 'America/Mexico_City',
    support_doc_link: 'https://learn.teletracnavman.net/Help/TN360/es-MX/Default.htm',
  },
  CA: {
    country: 'Canada',
    ...REGION_LOCALE.CA,
    time: {
      pm: 'PM',
      am: 'AM',
      formats: {
        default: 'YYYY-MM-DD',
        dby_hm: 'YYYY-MM-DD HH:mm',
        dby_hms_z: 'YYYY-MM-DDTHH:mm:ssZ',
        dby_imp: 'YYYY MMM DD hh:mm A',
        dby_imsp: 'YYYY MMM DD hh:mm:ss A',
        dby_imsp_moment: 'YYYY MMM DD hh:mm:ss',
        dby: 'YYYY MMM DD',
        bd_hm: 'MMM DD, h:mm A',
        bdo_hm: 'MMM Do, h:mm A',
        bdo_hm_z: 'MMM DD, h:mm A (Z)',
        dby_hm_z: 'YYYY MMM DD HH:mm ZZ',
        dmY_imsp: 'YYYY/MM/DD hh:mm:ss A',
        dmY_imp: 'YYYY/MM/DD hh:mm A',
        dmY: 'YYYY/MM/DD',
        AdBY: 'dddd, YYYY MMMM DD',
        dMy: 'Y M D',
        Md: 'MMM DD'
      },
      formats24H: {
        default: 'YYYY-MM-DD',
        dby_hm: 'YYYY-MM-DD HH:mm',
        dby_hms_z: 'YYYY-MM-DDTHH:mm:ssZ',
        dby_imp: 'YYYY MMM DD HH:mm',
        dby_imsp: 'YYYY MMM DD HH:mm:ss',
        dby_imsp_moment: 'YYYY MMM DD HH:mm:ss',
        dby: 'YYYY MMM DD',
        bd_hm: 'MMM DD, HH:mm',
        bdo_hm: 'MMM Do, HH:mm',
        bdo_hm_z: 'MMM DD, HH:mm (Z)',
        dby_hm_z: 'YYYY MMM DD HH:mm ZZ',
        dmY_imsp: 'YYYY/MM/DD HH:mm:ss',
        dmY_imp: 'YYYY/MM/DD HH:mm',
        dmY: 'YYYY/MM/DD',
        AdBY: 'dddd, YYYY MMMM DD',
        dMy: 'Y M D',
        Md: 'MMM DD'
      },
      formats12H: {
        default: 'YYYY-MM-DD',
        dby_hm: 'YYYY-MM-DD hh:mm A',
        dby_hms_z: 'YYYY-MM-DDTHH:mm:ssZ',
        dby_imp: 'YYYY MMM DD hh:mm A',
        dby_imsp: 'YYYY MMM DD hh:mm:ss A',
        dby_imsp_moment: 'YYYY MMM DD hh:mm:ss A',
        dby: 'YYYY MMM DD',
        bd_hm: 'MMM DD, h:mm A',
        bdo_hm: 'MMM Do, h:mm A',
        bdo_hm_z: 'MMM DD, h:mm A (Z)',
        dby_hm_z: 'YYYY MMM DD hh:mm A ZZ',
        dmY_imsp: 'YYYY/MM/DD hh:mm:ss A',
        dmY_imp: 'YYYY/MM/DD hh:mm A',
        dmY: 'YYYY/MM/DD',
        AdBY: 'dddd, YYYY MMMM DD',
        dMy: 'Y M D',
        Md: 'MMM DD'
      }
    },
    default_time_zone: 'Canada/Eastern',
    support_email: 'tn360support-au@teletracnavman.com',
    support_doc_link: 'https://learn.teletracnavman.net/Help/TN360/en-CA/Default.htm',
  },
  FR: {
    country: 'France',
    ...REGION_LOCALE.FR,
    time: baseTimeConfig,
    default_time_zone: 'Europe/Paris',
    support_email: 'tn360support-au@teletracnavman.com',
    support_doc_link: 'https://learn.teletracnavman.net/Help/TN360/en-GB/Default.htm',
  },
  DK: {
    country: 'Denmark',
    ...REGION_LOCALE.DK,
    time: baseTimeConfig,
    default_time_zone: 'Europe/Paris',
    support_email: 'tn360support-au@teletracnavman.com',
    support_doc_link: 'https://learn.teletracnavman.net/Help/TN360/en-GB/Default.htm',
  },
  CL: {
    country: 'Chile',
    ...REGION_LOCALE.CL,
    time: baseTimeConfig,
    default_time_zone: 'America/Santiago',
    support_email: 'tn360support-au@teletracnavman.com',
    support_doc_link: 'https://learn.teletracnavman.net/Help/TN360/es-MX/Default.htm'
  }
};